!function (t, o) {
  "object" == typeof exports && "object" == typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define([], o) : "object" == typeof exports ? exports["menthor-formatter"] = o() : t.MenthorFormatter = o();
}(window, function () {
  return function (t) {
    var o = {};
    function c(n) {
      if (o[n]) return o[n].exports;
      var e = o[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(e.exports, e, e.exports, c), e.l = !0, e.exports;
    }
    return c.m = t, c.c = o, c.d = function (t, o, n) {
      c.o(t, o) || Object.defineProperty(t, o, {
        enumerable: !0,
        get: n
      });
    }, c.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, c.t = function (t, o) {
      if (1 & o && (t = c(t)), 8 & o) return t;
      if (4 & o && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (c.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & o && "string" != typeof t) for (var e in t) c.d(n, e, function (o) {
        return t[o];
      }.bind(null, e));
      return n;
    }, c.n = function (t) {
      var o = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return c.d(o, "a", o), o;
    }, c.o = function (t, o) {
      return Object.prototype.hasOwnProperty.call(t, o);
    }, c.p = "", c(c.s = 1);
  }([function (t, o) {
    var c = function c() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          o = /(\d{4})-(\d{2})-(\d{2})/.exec(t);
        return o ? new Date(o[1], o[2] - 1, o[3]) : new Date();
      },
      n = function n(t) {
        return "string" == typeof t ? 0 === t.trim().length : null == t;
      },
      e = ["jan.", "fev.", "mar.", "abr.", "mai.", "jun.", "jul.", "ago.", "set.", "out.", "nov.", "dez."];
    t.exports = {
      isBlank: n,
      formatAuthor: function formatAuthor(t, o) {
        var c = t.split(" ");
        if (0 === c.length) return "";
        var n = c.pop().toUpperCase();
        return 0 === c.length ? n : o ? "".concat(n, ", ").concat(c.map(function (t) {
          return t.charAt(0);
        }).join(". "), ".") : c.length > 2 ? "".concat(n, ", ").concat(c.map(function (t) {
          return t.charAt(0);
        }).join(". ")) : "".concat(n, ", ").concat(c.join(" "));
      },
      formatAccessDate: function formatAccessDate(t) {
        if (n(t)) return "";
        var o = c(t);
        return "".concat(o.getDate(), " ").concat(e[o.getMonth()], " ").concat(o.getFullYear());
      },
      months: e,
      parseDate: c
    };
  }, function (t, o, c) {
    var n = c(2),
      e = c(3),
      a = c(4);
    t.exports = {
      articleFormatter: n,
      bookFormatter: e,
      siteFormatter: a
    };
  }, function (t, o, c) {
    var n = c(0),
      e = n.isBlank,
      a = n.formatAuthor,
      r = n.formatAccessDate,
      i = n.months,
      u = n.parseDate;
    t.exports = function (t) {
      var o = t.title,
        c = void 0 === o ? "" : o,
        n = t.subtitle,
        l = void 0 === n ? "" : n,
        s = t.authors,
        d = void 0 === s ? [] : s,
        f = t.firstPage,
        v = void 0 === f ? "" : f,
        p = t.lastPage,
        m = void 0 === p ? "" : p,
        b = t.place,
        g = void 0 === b ? "" : b,
        h = t.journalTitle,
        j = void 0 === h ? "" : h,
        y = t.journalSubtitle,
        D = void 0 === y ? "" : y,
        O = t.volume,
        x = void 0 === O ? "" : O,
        A = t.number,
        S = void 0 === A ? "" : A,
        M = t.publicationDate,
        w = void 0 === M ? "" : M,
        E = t.url,
        N = void 0 === E ? "" : E,
        P = t.accessDate,
        B = void 0 === P ? "" : P,
        T = function (t) {
          return 0 === t.length || e(t[0]) ? "" : t.length > 3 ? a(t[0], !0) + " et al" : t.map(function (t) {
            return a(t);
          }).join("; ");
        }(d),
        F = T.replace(/(et al)$/, "<i>$1</i>"),
        Y = function (t) {
          if (e(t)) return "";
          var o = u(t);
          return "".concat(i[o.getMonth()], "/").concat(o.getFullYear());
        }(w),
        _ = r(B),
        k = e(l) ? "" : ": ".concat(l),
        R = e(D) ? "" : ": ".concat(D),
        X = e(v) ? "" : "p. ".concat(v),
        $ = e(v) || e(m) ? "" : "-".concat(m),
        z = "",
        H = "";
      e(N) || e(B) || (z = " Disponível em: ".concat(N, ". Acesso em: ").concat(_, "."), H = " Disponível em: ".concat(N, ". Acesso em: ").concat(_, "."));
      var C = "".concat(T, ". ").concat(c).concat(k, ". ").concat(j).concat(R, ", ").concat(g, ", v. ").concat(x, ", n. ").concat(S, ", ").concat(X).concat($, ", ").concat(Y, ".").concat(z),
        U = "".concat(F, ". ").concat(c).concat(k, ". <b>").concat(j, "</b>").concat(R, ", ").concat(g, ", v. ").concat(x, ", n. ").concat(S, ", ").concat(X).concat($, ", ").concat(Y, ".").concat(H),
        I = e(j) ? "Título da revista" : j,
        L = e(j) || e(D) ? ": subtítulo da revista" : ": ".concat(D),
        V = e(x) ? "Volume" : "v. ".concat(x),
        q = e(S) ? "Número" : "n. ".concat(S),
        G = Y || "dez./2005",
        J = e(c) ? "Título do artigo" : c,
        K = e(c) || e(l) ? ": subtítulo do artigo" : ": ".concat(l),
        Q = e(T) ? "SOBRENOME, Nome do autor; SOBRENOME, Nome do autor" : F,
        W = e(g) ? "Local" : g,
        Z = e(v) ? "XX" : v,
        tt = "-YY";
      return e(v) || (tt = e(m) ? "" : "-".concat(m)), {
        plain: C,
        html: U,
        previewHtml: "".concat(Q, ". ").concat(J).concat(K, ". <b>").concat(I, "</b>").concat(L, ", ").concat(W, ", ").concat(V, ", ").concat(q, ", p. ").concat(Z).concat(tt, ", ").concat(G, ".").concat(H)
      };
    };
  }, function (t, o, c) {
    var n = c(0),
      e = n.isBlank,
      a = n.formatAuthor,
      r = function r(t, o) {
        return e(t) && e(o) ? "[S.l.: s.n.]" : e(t) ? "[S.l.]: ".concat(o) : e(o) ? "".concat(t, ": [s.n.]") : "".concat(t, ": ").concat(o);
      };
    t.exports = function (t) {
      var o = t.title,
        c = void 0 === o ? "" : o,
        n = t.subtitle,
        i = void 0 === n ? "" : n,
        u = t.authors,
        l = void 0 === u ? [] : u,
        s = t.edition,
        d = void 0 === s ? "" : s,
        f = t.firstPage,
        v = void 0 === f ? "" : f,
        p = t.lastPage,
        m = void 0 === p ? "" : p,
        b = t.place,
        g = void 0 === b ? "" : b,
        h = t.publisher,
        j = void 0 === h ? "" : h,
        y = t.year,
        D = void 0 === y ? "" : y,
        O = function (t) {
          return 0 === t.length || e(t[0]) ? "" : t.length > 3 ? a(t[0], !0) + " et al." : t.map(function (t) {
            return a(t);
          }).join("; ") + ";";
        }(l),
        x = O.replace(/(et al).$/, "<i>$1</i>."),
        A = e(i) ? "" : ": ".concat(i),
        S = e(v) ? "" : ". p. ".concat(v),
        M = e(v) || e(m) ? "" : "-".concat(m),
        w = r(g, j),
        E = "".concat(O, " ").concat(c).concat(A, ". ").concat(d, ". ed. ").concat(w, ", ").concat(D).concat(S).concat(M, "."),
        N = "".concat(x, " <b>").concat(c, "</b>").concat(A, ". ").concat(d, ". ed. ").concat(w, ", ").concat(D).concat(S).concat(M, "."),
        P = e(c) ? "Título do livro" : c,
        B = e(c) || e(i) ? ": subtítulo do livro" : ": ".concat(i),
        T = e(O) ? "SOBRENOME, Nome do autor; SOBRENOME, Nome do autor;" : x,
        F = e(d) ? "Edição" : "".concat(d, ". ed"),
        Y = r(g, j),
        _ = e(D) ? "ano" : D,
        k = e(v) ? "XX" : v,
        R = e(v) || e(m) ? "YY" : m;
      return {
        plain: E,
        html: N,
        previewHtml: "".concat(T, " <b>").concat(P, "</b>").concat(B, ". ").concat(F, ". ").concat(Y, ", ").concat(_, ". p. ").concat(k, "-").concat(R, ".")
      };
    };
  }, function (t, o, c) {
    var n = c(0),
      e = n.isBlank,
      a = n.formatAccessDate;
    t.exports = function (t) {
      var o = t.name,
        c = void 0 === o ? "" : o,
        n = t.title,
        r = void 0 === n ? "" : n,
        i = t.url,
        u = void 0 === i ? "" : i,
        l = t.accessDate,
        s = a(void 0 === l ? "" : l),
        d = e(r) ? "Título da matéria" : r,
        f = e(c) ? "NOME DO SITE" : c.toUpperCase(),
        v = e(u) ? "www.site.com" : u,
        p = e(s) ? "30 dez. 2005" : s;
      return {
        plain: "".concat(c, ". ").concat(r, ". Disponível em: ").concat(u, ". Acesso em: ").concat(s, "."),
        html: "".concat(c, ". <b>").concat(r, "</b>. Disponível em: ").concat(u, ". Acesso em: ").concat(s, "."),
        previewHtml: "".concat(f, ". <b>").concat(d, "</b>. Disponível em: ").concat(v, ". Acesso em: ").concat(p, ".")
      };
    };
  }]);
});